import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const AuthenticationsServices = {
  // Define your API functions here
  // getList: async () => {
  //   const response = await apiService.get('/good-category');
  //   return response.data;
  // },
  changePassword: async (changeData) => {
    try {
      const response = await apiService.post(
        `${slug}/auth/change-password`,
        changeData
      );
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      throw new Error("Failed to change password. Please try again.");
    }
  },

  Register: async (registeradmin) => {
    try {
      const response = await apiService.post(
        `/${slug}/auth/user-register`,
        registeradmin
      );
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      throw new Error("Failed to change password. Please try again.");
    }
  },

  verify: async ({ email, OTP }) => {
    const response = await apiService.get(`/${slug}/validate-otp`, {
      params: { email, OTP }, // Send as query parameters
    });
    return response.data;
  },

  resetPassword: async (resetData) => {
    const response = await apiService.post(`/auth/reset-password`, resetData);
    return response.data;
  },
  forgotPassword: async (forgotPwdData) => {
    const response = await apiService.post(
      `/auth/forgot-password`,
      forgotPwdData
    );
    return response.data;
  },
  userRole: async (resetData) => {
    const response = await apiService.get(`/auth/roles`);
    return response.data;
  },
  userRoleManage: async (resetData) => {
    const response = await apiService.get(`/auth/get-users`);
    return response.data;
  },

  viewdata: async (userId) => {
    const response = await apiService.get(`/auth/get-user/${userId}`);
    return response.data;
  },

  // view: async (id) => {
  //   const response = await apiService.get(`/good-category/${id}`);
  //   return response.data;
  // },
  delete: async (id) => {
    const response = await apiService.delete(`/auth/${id}`);
    return response.data;
  },
  updateregister: async (id, updatedData) => {
    const response = await apiService.put(`/auth/${id}`, updatedData);
    return response.data;
  },
};

export default AuthenticationsServices;
